import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import classes from './style.module.scss';

interface Properties {
  readonly className?: string;
  readonly children: ReactNode;
}

const Box = ({ className, children }: Properties): ReactElement => (
  <section className={classNames(classes.box, className)}>{children}</section>
);

export default Box;
